import { HttpHandler, HttpRequest, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { LoadingDialogService } from '@app/shared/components/loading/loading-dialog.service';
import { Injectable } from '@angular/core';

/**
 * This is just for displaying the loading box whenever an API call is made. Not about errors.
 */
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private loadingDialogService: LoadingDialogService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.loadingDialogService.openDialog();
    return next.handle(request).pipe(
      catchError((httpErrorResponse: HttpErrorResponse) => {
        // if (httpErrorResponse) {
        //   switch(httpErrorResponse.status) {
        //     case 401: // Unauthorized
        //       this._authTokenService.removeTokens('session_expired')
        //       break;
        //     // TODO - add error code here
        //     case 404:
        //       this._router.navigate(['error'],
        //       { 
        //         state: { 
        //           error: {
        //             title: 'Yes Not Found',
        //             description: 'I am a description'
        //           } 
        //         } 
        //       })
        //       break;
        //   }
        // }
        this.loadingDialogService.hideDialog()
        throw httpErrorResponse
      }),
      finalize(() => {
        this.loadingDialogService.hideDialog();
      })
    ) as Observable<HttpEvent<any>>;
  }
}
